import { directions } from "../../../../constans/directions";
import ProjectTags from "../../../Companies/SelectedCompany/CompanyPrograms/CreateProgram/ProjectTags/ProjectTags";
import s from "../ProjectFormPage.module.css";
import { ProjectFormController } from "../useProjectFormController";

type TagsStepProps = {
  controller: ProjectFormController;
};

const TagsStep = ({ controller }: TagsStepProps) => {
  const selectedSpecializations = controller.mainSpecializations.filter(
    (item) => controller.selectedSpecializationIds.includes(item.value),
  );

  return (
    <div className={s.stepPanel}>
      <div className={s.section}>
        <h2 className={s.sectionTitle}>Tags</h2>
        <p className={s.sectionText}>
          Configure Project tags for each selected specialization.
        </p>
      </div>

      {selectedSpecializations.length ? (
        selectedSpecializations.map((specialization) => (
          <ProjectTags
            key={specialization.value}
            mainSpecialization={specialization.specialization}
            setProjectTags={controller.setProjectTags}
            oldProjectTags={controller.existingTags.filter(
              (tag) =>
                tag.direction === directions[specialization.specialization],
            )}
          />
        ))
      ) : (
        <div className={s.emptyState}>
          Select specializations before configuring Project tags.
        </div>
      )}
    </div>
  );
};

export default TagsStep;
